<template>
  <Select
    :clearable="clearable"
    :disabled="disabled"
    :filterable="filterable"
    :multiple="multiple"
    :placeholder="placeholder"
    :transfer="transfer"
    @on-change="changeValue"
    label-in-value
    v-model="val"
  >
    <Option
      :key="item + category + '-' + index"
      :value="item.val"
      v-for="(item, index) in options"
    >{{item.label}}</Option>
  </Select>
</template>
<script>
export default {
  name: 'labelValue',
  props: {
    multiple: {
      required: false,
      default: false
    },
    clearable: {
      required: false,
      default: true
    },
    filterable: {
      required: false,
      default: true
    },
    category: {
      required: true
    },
    placeholder: {
      required: false,
      default: '请选择'
    },
    disabled: {
      required: false,
      default: false
    },
    transfer: {
      required: false,
      default: false
    },
    data: { required: false }
  },
  data () {
    return {
      options: [],
      val: null
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function (newValue, oldValue) {
        this.val = newValue || (this.multiple ? [] : '')
      }
    },
    category: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (newValue != oldValue) {
          this.initOpts()
        }
      }
    }

  },
  methods: {
    changeValue: function (val) {
      console.log('changeValue', val)
      if (!val) {
        val = {}
      }
      if (this.multiple) {
        // this.val = val.map(item => item.value)
        let values = []
        let labels = []
        val.forEach(element => {
          values.push(element.value)
          labels.push(element.label)
        })
        // this.val = values
        this.$emit('change', values, labels)
      } else {
        // this.val = val.value
        this.$emit('change', val.value, val.label)
      }

    },
    initOpts: function () {
      let that = this
      this.getDic(this.category).then(val => {
        that.options = val
        that.$emit('init', that.options)
      })
    }
  },
  beforeMount () {
    this.initOpts()
  }
}
</script>